import { defineMessages } from 'react-intl';

export default defineMessages({
    header: {
        id: 'ml.quoteandbind.common.employeraffilitationnonservicingstates.header',
        defaultMessage: 'This group may not be participating in our group discount program.'
    },
    retrySearch: {
        id: 'ml.quoteandbind.common.employeraffilitationnonservicingstates.retrySearch',
        defaultMessage: 'Try entering another employer or group.'     
    },
    skipDiscount: {
        id: 'ml.quoteandbind.common.employeraffilitationnonservicingstates.skipDiscount',
        defaultMessage: 'You can also continue without an affiliation. We\'ll look for other discounts along the way!'    
    }
});
